// minimum value of cadenceDaysOut when we mark entity as UP TO DATE
export const FREQUENCY_OUT_BREAKPOINT = -3;

export const ACTIVITIES_PORTION_SIZE = 3;
